// Utility functions per estrarre informazioni dagli errori di eliminazione utenti

/**
 * Estrae la lista delle target lists dal messaggio di errore gestendo parentesi nei nomi
 * @param errorMessage Messaggio di errore del server
 * @returns Array di nomi delle target lists
 */
export function extractTargetListsFromError(errorMessage: string): string[] {
    if (!errorMessage) return [];

    const startPattern = "target lists: [";
    const startIndex = errorMessage.indexOf(startPattern);

    if (startIndex === -1) return [];

    const contentStartIndex = startIndex + startPattern.length;

    let bracketCount = 1;
    let endIndex = -1;

    for (let i = contentStartIndex; i < errorMessage.length; i++) {
        if (errorMessage[i] === '[') {
            bracketCount++;
        } else if (errorMessage[i] === ']') {
            bracketCount--;
            if (bracketCount === 0) {
                endIndex = i;
                break;
            }
        }
    }

    if (endIndex === -1) return [];

    const content = errorMessage.substring(contentStartIndex, endIndex);
    if (!content.trim()) return [];

    return parseTargetLists(content);
}

/**
 * Parsa le target lists gestendo virgole dentro parentesi quadre
 */
function parseTargetLists(content: string): string[] {
    const lists: string[] = [];
    let current = '';
    let bracketCount = 0;

    for (const char of content) {
        if (char === '[') {
            bracketCount++;
            current += char;
        } else if (char === ']') {
            bracketCount--;
            current += char;
        } else if (char === ',' && bracketCount === 0) {
            if (current.trim()) {
                lists.push(current.trim());
            }
            current = '';
        } else {
            current += char;
        }
    }

    if (current.trim()) {
        lists.push(current.trim());
    }

    return lists;
}

/**
 * Verifica se l'errore è relativo a un utente assegnato a target lists
 */
export function isTargetListsAssignmentError(error: any): boolean {
    return error?.status === 500 &&
        error?.data?.errors?.some((e: { message: string }) =>
            e.message.includes("is assigned to target lists")
        );
}

/**
 * Estrae le informazioni complete dall'errore di eliminazione utente
 */
export function extractDeleteUserErrorInfo(error: any) {
    if (!isTargetListsAssignmentError(error)) {
        return { projects: [], targets: [], isTargetListsError: false };
    }

    const errorMessage = error.data.errors.find((e: { message: string }) =>
        e.message.includes("is assigned to target lists")
    )?.message || '';

    return {
        projects: error.data.projects || [],
        targets: extractTargetListsFromError(errorMessage),
        isTargetListsError: true
    };
}

